module.exports = __webpack_public_path__ + "img/knapp_logo.5a438f0e.svg";